import React from 'react';
import './DropdownInput.scss';
import { EInputColor } from './types';

export interface IDropdownOption {
  value: string;
  label: string;
}

export interface IDropdownInputProps {
  className?: string;
  color?: EInputColor;
  error?: string;
  initialValue?: string;
  name?: string;
  placeholder: string;
  required?: boolean;
  labelledBy?: string;
  options: IDropdownOption[];
  onChange: (value: string) => void;
}

const DropdownInput: React.FC<React.PropsWithChildren<IDropdownInputProps>> = ({
  children,
  className,
  color = EInputColor.Dark,
  error,
  initialValue,
  name,
  placeholder,
  required,
  labelledBy,
  options,
  onChange,
}) => {
  const errorClass = error ? ' is-invalid' : '';
  const changeHandler: React.ChangeEventHandler<HTMLSelectElement> = (e) => onChange(e.target.value);
  const blurHandler: React.FocusEventHandler<HTMLSelectElement> = (e) => onChange(e.target.value);

  return (
    <div className={`dropdown-input-container${errorClass} ${color} ${className ?? ''}`}>
      <div className="input-wrapper">
        <select
          name={name}
          id={name}
          aria-labelledby={labelledBy}
          onChange={changeHandler}
          defaultValue={initialValue ?? ''}
          className="dropdown-input"
          required={required}
          onBlur={blurHandler}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {children}
      </div>
      <div className="error-feedback">{error ?? null}</div>
    </div>
  );
};

export default DropdownInput;
